import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Box, Popover, IconButton } from "@material-ui/core";
import { CloseIcon } from "@hapinest/theme";

const useStyles = makeStyles((theme) => ({
    popoverHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: theme.spacing(0.5),
        paddingRight: theme.spacing(1.5),
        paddingLeft: theme.spacing(1.5),
        "& button": {
            marginLeft: theme.spacing(2)
        }
    }
}));

const ApartmentGuestInfoPopover = ({
    anchorEl,
    onClose,
    apartmentCategoryGuestInfo,
    ...props
}) => {
    const classes = useStyles();

    const handleClose = () => {
        onClose();
    };

    const open = Boolean(anchorEl);

    return (
        <Popover
            id="guestinfo-popover"
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            onClose={handleClose}
            {...props}
        >
            <Box
                className={classes.popoverHeader}
            >
                <Typography
                    variant="subtitle1"
                >
                    {apartmentCategoryGuestInfo?.title}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                >
                    <CloseIcon/>
                </IconButton>
            </Box>
            <Box
                pb={1}
                px={1.5}
                maxWidth={"320px"}
            >
                <Typography
                    variant="body2"
                >
                    {apartmentCategoryGuestInfo?.description}
                </Typography>
            </Box>
        </Popover>
    );
};

ApartmentGuestInfoPopover.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func,
    apartmentCategoryGuestInfo: PropTypes.object,
};

export default ApartmentGuestInfoPopover;
